import { render } from "./WheelchairModal.vue?vue&type=template&id=4f8077b8&scoped=true&lang=pug"
import script from "./WheelchairModal.vue?vue&type=script&lang=ts"
export * from "./WheelchairModal.vue?vue&type=script&lang=ts"

import "./WheelchairModal.vue?vue&type=style&index=0&id=4f8077b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f8077b8"

export default script